(function() {
  //console.log('Custom Add to Cart script loaded');

  function initCustomAddToCart() {
    //console.log('Initializing Custom Add to Cart');

    var CustomAddToCart = {
      init: function() {
        this.initQuickAddToCart();
      },

      initQuickAddToCart: function() {
        //console.log('Setting up quick add to cart click handler');
        document.addEventListener('click', function(event) {
          if (event.target.classList.contains('js-quick-add-to-cart')) {
            //console.log('Quick add button clicked', event.target);
            event.preventDefault();
            event.stopPropagation();

            var btn = event.target;
            var productId = btn.getAttribute('data-product-id');
            var productHandle = btn.getAttribute('data-product-handle');

            //console.log('Product ID:', productId, 'Product Handle:', productHandle);

            // 显示加载状态
            btn.classList.add('btn--loading');

            // 获取产品数据
            fetch('/products/' + productHandle + '.js')
              .then(response => response.json())
              .then(product => {
                //console.log('Product data received:', product);
                if (product.variants.length > 1) {
                  //console.log('Multiple variants found, showing selector');
                  CustomAddToCart.showVariantSelector(product, btn);
                } else {
                 // console.log('Single variant found, adding to cart');
                  CustomAddToCart.addToCart(product.variants[0].id, 1, btn);
                }
              })
              .catch(error => {
                console.error('Error fetching product data:', error);
                btn.classList.remove('btn--loading');
              });
          }
        });
      },

      showVariantSelector: function(product, btn) {
  // 创建一个模态窗口来显示变体选择器
  var modal = document.createElement('div');
  modal.className = 'variant-selector-modal';
  modal.innerHTML = '<div class="variant-selector-content">' +
    '<h3>' + product.title + '</h3>' +
    '<select id="variant-selector">' +
    product.variants.map(function(variant) {
      return '<option value="' + variant.id + '">' + variant.title + '</option>';
    }).join('') +
    '</select>' +
    '<button id="add-selected-variant">Add to Cart</button>' +
    '<button id="cancel-variant-selection">Cancel</button>' +
    '</div>';

  document.body.appendChild(modal);

  // 添加点击事件到模态窗口
  modal.addEventListener('click', function(event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  // 添加取消按钮的点击事件
  document.getElementById('cancel-variant-selection').addEventListener('click', closeModal);

  document.getElementById('add-selected-variant').addEventListener('click', function() {
    var selectedVariantId = document.getElementById('variant-selector').value;
    CustomAddToCart.addToCart(selectedVariantId, 1, btn);
    closeModal();
  });

  // 关闭模态窗口的函数
  function closeModal() {
    modal.remove();
    btn.classList.remove('btn--loading');
  }

  // 添加键盘事件监听器，以支持 Esc 键关闭
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
},

      addToCart: function(variantId, quantity, btn) {
        //console.log('Adding to cart:', variantId, quantity);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
        .then(response => response.json())
        .then(item => {
          //console.log('Successfully added to cart:', item);
          this.updateCartState();
          btn.classList.remove('btn--loading');
          // 可以在这里添加成功消息
          this.showNotification('Item added to cart!');
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          btn.classList.remove('btn--loading');
          this.showNotification('Error adding item to cart. Please try again.');
        });
      },

      updateCartState: function() {
      console.log('Updating cart state');
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('Cart updated:', cart);
          this.updateCartCount(cart.item_count);
        })
        .catch(error => {
          console.error('Error updating cart:', error);
        });
    },

      updateCartCount: function(count) {
      // 更新购物车计数
      var cartCountElements = document.querySelectorAll('.cart-count-bubble');
      cartCountElements.forEach(function(element) {
        if (count > 0) {
          element.textContent = count;
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      });

        // 更新购物车气泡
      var cartBubble = document.querySelector('.cart-link__bubble');
      if (cartBubble) {
        if (count > 0) {
          cartBubble.classList.add('cart-link__bubble--visible');
        } else {
          cartBubble.classList.remove('cart-link__bubble--visible');
        }
      }
    },

      showNotification: function(message) {
        var notification = document.createElement('div');
        notification.className = 'cart-notification';
        notification.textContent = message;
        document.body.appendChild(notification);
        setTimeout(function() {
          notification.remove();
        }, 3000);
      }
    };

    CustomAddToCart.init();

    // 打印按钮数量，用于调试
   // console.log('Number of Add to Cart buttons:', document.querySelectorAll('.js-quick-add-to-cart').length);
  }

  // 在 DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomAddToCart);
  } else {
    initCustomAddToCart();
  }
})();

// 外部链接处理代码
document.addEventListener('DOMContentLoaded', function() {
  // 获取当前网站的域名
  var currentDomain = window.location.hostname;

  // 选择所有的a标签
  var links = document.getElementsByTagName('a');

  // 遍历所有链接
  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    var href = link.href;

    // 检查链接是否是外部链接
    if (href && !href.startsWith('#') && !href.startsWith('javascript:') && !href.includes(currentDomain)) {
      // 添加 target="_blank" 如果不存在
      if (!link.getAttribute('target') || link.getAttribute('target') !== '_blank') {
        link.setAttribute('target', '_blank');
      }

      // 添加 rel 属性
      var rel = link.getAttribute('rel') || '';
      var relValues = rel.split(' ');

      // 检查并添加缺失的值
      ['noreferrer', 'noopener', 'nofollow'].forEach(function(value) {
        if (!relValues.includes(value)) {
          relValues.push(value);
        }
      });

      // 设置更新后的 rel 属性
      link.setAttribute('rel', relValues.join(' ').trim());
    }
  }
});

//在导航中插入gif标志

document.addEventListener('DOMContentLoaded', function() {
  const navItems = document.querySelectorAll('.site-nav__item a');
  const hotItems = ['sports']; // 添加您想标记为"hot"的项目
  const newItems = ['outlet']; // 添加您想标记为"sale"的项目

  navItems.forEach(item => {
    const text = item.textContent.trim().toLowerCase();
    if (hotItems.includes(text)) {
      item.classList.add('ss-hot');
    } else if (newItems.includes(text)) {
      item.classList.add('ss-sale');
    }
  });
});
